export default __webpack_public_path__ + "static/media/logoNoText.219261c1.png";